import classNames from 'classnames'

export const Label = ({ text }: { text: string }) => {
    const classNamesLabel = classNames('strong', 'label');
    return <h1 className={classNamesLabel}>{text}</h1>;
}